import {z} from 'zod';

export const mechanicFilterOptionsResponseSchema = z.object({
  mechanics: z.array(z.string()),
  states: z.array(z.string()),
  variants: z.array(z.string()),
});

export type MechanicFilterOptions = z.infer<typeof mechanicFilterOptionsResponseSchema>;
